import { PulseStorage } from '@pulse/common';

export class WebToMobileService {
    private readonly KEY_W2M_META_INFO: string = 'w2m_meta_info';
    private w2mMetaInfo?: Record<string, any> | null;

    constructor(protected readonly cookieStorage: PulseStorage) {
        try {
            const w2mMetaInfo = this.cookieStorage.get(this.KEY_W2M_META_INFO);

            if (w2mMetaInfo) {
                this.w2mMetaInfo = JSON.parse(w2mMetaInfo);
            }
        } catch (e) {
            console.error('Error getting web to mobile configuration', e);
        }
    }

    /**
     * Get the device unique identifier
     */
    getWebToMobileMetaInfo(): Record<string, any> | null {
        if (this.w2mMetaInfo) {
            return this.w2mMetaInfo;
        }

        return null;
    }
}
